/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Updated_ToInputs */



/**
* | output |
* | --- |
* | "Updated to" |
*
* @param {Explorer_Search_Updated_ToInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_updated_to = /** @type {((inputs?: Explorer_Search_Updated_ToInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Updated_ToInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Updated to")
	if (locale === "de") return /** @type {LocalizedString} */ ("Updated to")
	if (locale === "it") return /** @type {LocalizedString} */ ("Updated to")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Updated to")
	if (locale === "es") return /** @type {LocalizedString} */ ("Updated to")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Updated to")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Updated to")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Updated to")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Updated to")
	return /** @type {LocalizedString} */ ("Updated to")
});